import {
  cardReferenceRegionSchema,
  type CardReferenceRegion,
} from '../../shared/card-reference.ts';

export type PdfLocation = {
  referenceDocumentId: string;
  deckId: string;
  page: number;
  region?: CardReferenceRegion;
};

export function readPdfLocation(url: URL): PdfLocation | null {
  if (url.pathname !== '/pdf') return null;
  const referenceDocumentId = url.searchParams.get('document');
  const deckId = url.searchParams.get('deck');
  if (!referenceDocumentId || !deckId) return null;
  const requestedPage = Number(url.searchParams.get('page'));
  const page =
    Number.isSafeInteger(requestedPage) && requestedPage > 0
      ? requestedPage
      : 1;
  const regionSource = url.searchParams.get('region');
  let region: CardReferenceRegion | undefined;
  if (regionSource) {
    try {
      const parsed = cardReferenceRegionSchema.safeParse(
        JSON.parse(regionSource),
      );
      if (parsed.success) region = parsed.data;
    } catch {
      // Keep the page location usable when the optional region is malformed.
    }
  }
  return region
    ? { referenceDocumentId, deckId, page, region }
    : { referenceDocumentId, deckId, page };
}

export function pdfViewerUrl(location: PdfLocation): string {
  const params = new URLSearchParams({
    document: location.referenceDocumentId,
    deck: location.deckId,
    page: String(location.page),
  });
  if (location.region) params.set('region', JSON.stringify(location.region));
  return `/pdf?${params}`;
}
